<template>
  <v-dialog
    id="reservations-delete-modal"
    v-model="deleteModal"
    width="400"
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ message }}
        <div class="button-group mt-10">
          <v-btn
            text
            @click="() => this.$emit('close-delete-modal')"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="() => this.$emit('confirm-deletion')"
          >
            {{ confirmationButton }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DeleteReservationsModal',
    props: {
      deleteModal: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      message: {
        type: String,
        default: '',
      },
      confirmationButton: {
        type: String,
        default: '',
      },
    },
  }
</script>
